import { useTranslations } from 'next-intl';
import { JobPhotosFragment } from '../gen/graphql/JobRoute.generated';
import Image from 'next/image';
import { JobContentSection } from './JobContentSection';

export interface JobPhotosProps {
  jobPhotos: JobPhotosFragment;
}

export function JobPhotos({ jobPhotos }: JobPhotosProps) {
  const t = useTranslations();
  if (!jobPhotos.photos || jobPhotos.photos.length === 0) {
    return null;
  }
  return (
    <JobContentSection emoji="📸" title={t('job.jobContentSection.photos')}>
      <div className="flex flex-row flex-wrap gap-2">
        {jobPhotos.photos?.map((photo) => (
          <div
            key={photo.id}
            className="w-[100px] h-[100px] relative overflow-hidden rounded-small"
          >
            <Image className="object-cover" src={photo.imageURL} alt="" fill />
          </div>
        ))}
      </div>
    </JobContentSection>
  );
}
